export enum SavedStripedMethodsListActionTypes {
  FETCHING_SAVED_STRIPE_PAYMENT_METHODS = 'payment/FETCHING_SAVED_STRIPE_PAYMENT_METHODS',
  SAVED_STRIPE_PAYMENT_METHODS_RECEIVED = 'payment/SAVED_STRIPE_PAYMENT_METHODS_RECEIVED',
}
